export default {
  state: {
    menuState: {
      active: true,
      message: ''
    }
  },
  mutations: {
    setMenuState (state, payload) {
      state.menuState = payload
    }
  },
  actions: {
    setMenuState  ({commit}, payload) {
      commit('setMenuState', payload)
    }
  },
  getters: {
    menuState (state) {
      return state.menuState
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/menuState.js